import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../components/SectionHeading";
import IconBadge from "../../components/IconBadge";
import { homeIcons } from "./homeIcons";
import { industriesContent } from "./homeContent";

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
};

const HomeIndustries = () => (
  <section
    className="bg-white py-14 lg:py-20"
    aria-labelledby="home-industries-heading"
  >
    <div className="sectionlayout">
      <SectionHeading
        id="home-industries-heading"
        title={industriesContent.title}
        subtitle={industriesContent.intro}
        subtitleAs="p"
        subtitleClassName="mx-auto max-w-xl text-sm md:text-base text-gray-600"
      />
      <motion.ul
        className="grid list-none grid-cols-1 gap-5 p-0 sm:grid-cols-2 lg:grid-cols-4"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.07 } } }}
      >
        {industriesContent.industries.map((industry) => {
          const Icon = homeIcons[industry.icon];
          return (
            <motion.li
              key={industry.name}
              variants={itemVariants}
              className="brand-card"
            >
              {/* opens this industry's section on the Industries page */}
              <Link
                to={industry.to}
                className="flex h-full items-center gap-4 px-5 py-5 rounded-[inherit] text-inherit hover:text-inherit focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-orange)]"
              >
                <IconBadge icon={Icon} size="sm" />
                <span className="text-sm md:text-base font-semibold text-gray-900">
                  {industry.name}
                </span>
              </Link>
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  </section>
);

export default HomeIndustries;
